import { tokens } from './tokens';

export type Breakpoint = 'phone' | 'tablet' | 'desktop';

export const BREAKPOINT_TABLET_PX = Number.parseInt(tokens.screens.tablet, 10);
export const BREAKPOINT_DESKTOP_PX = Number.parseInt(tokens.screens.desktop, 10);

export function breakpointFromWidth(width: number): Breakpoint {
  if (width >= BREAKPOINT_DESKTOP_PX) {
    return 'desktop';
  }
  if (width >= BREAKPOINT_TABLET_PX) {
    return 'tablet';
  }
  return 'phone';
}

export function isTabletUp(width: number): boolean {
  return width >= BREAKPOINT_TABLET_PX;
}

export function isDesktopUp(width: number): boolean {
  return width >= BREAKPOINT_DESKTOP_PX;
}
